export const EDITOR_GET_FORM = "EDITOR_GET_FORM";

export const EDITOR_SELECT_FIELD = "EDITOR_SELECT_FIELD";

export const EDITOR_UPDATE_FIELD = "EDITOR_UPDATE_FIELD";

export const EDITOR_ADD_FORM_FIELD = "EDITOR_ADD_FORM_FIELD";

export const EDITOR_DELETE_FIELD = "EDITOR_DELETE_FIELD";

export const EDITOR_SAVE_FORM = "EDITOR_SAVE_FORM";

export const EDITOR_DELETE_FORM = "EDITOR_DELETE_FORM";

export const EDITOR_CLEAR_FORM = "EDITOR_CLEAR_FORM";

export const EDITOR_UPDATE_FORM_SETTINGS = "EDITOR_UPDATE_FORM_SETTINGS";

export const EDITOR_REORDER_FIELDS = "EDITOR_REORDER_FIELDS";

export const EDITOR_COPY_FIELD = "EDITOR_COPY_FIELD";

export const EDITOR_CHANGE_FIELD_COMPONENT = "EDITOR_CHANGE_FIELD_COMPONENT";
